import React, {Component} from "react";
import Dom from '../../../../helpers/Dom';
import './GroupNav.css'

class GroupNav extends Component{
    constructor(props){
        super(props)
        let searchData;

        this.state = {
            filteredData: [],
            listBoxStatus: true,
            selectedItem: {}
        };
        this.isListBoxOpened = () => {
            return this.state.listBoxStatus && this.state.filteredData.length
        };
        this.isListItemActive = item => {
            return this.state.selectedListItem && item && this.state.selectedListItem.id === item.id;
        };
        this.setListItem = item => {
            this.setState({selectedListItem:item})
        };
        this.setMode = action => {
            this.selectedParent = action;
        };
        this.setItem = (item) => {
            if(!item) return;
            this.setState({selectedItem:item});
        };
        this.onSearchInputFocus = () => {
            this.setState({listBoxStatus: true})
        };
        this.clearSearchInputValue = () => {
            this.refs.searchInput.value = '';
        };
        this.onSearchInputBlur = () => {
            this.setState({listBoxStatus: false})
        };
        this.navigate = this.navigate.bind(this);
    }
    navigate = (item, index) => {
        if(index === 0)
            return;
             
        this.selectedGroup = item;
        if(this.props && this.props.navigate) {

            this.props.navigate(item);
            this.clearSearchInputValue();
            this.onSearchInputBlur();
        }
    };
   
    getGroupData =()=> {
        if(this.props.props) {
            return this.props.props.groups.length ? this.props.props.groups : []
        }
        return [];
    }
    makeListObject = (path, map, item) => {
        path = path.split('/');
        path = path.slice(1, path.length-1);
        let nameArray = [];
        let currentPath = "";
        for(let idx in path){
            currentPath += '/' + path[idx];
            if(map[currentPath+'/']) {
                nameArray.push(map[currentPath+'/'].name);
            }
        }
        item.nameArray = nameArray;
        return item;
    };
    search = () => {
        let str = this.refs.searchInput.value
        str.trim().toLowerCase();
            let filtered = [];
            let searchData = window.userGroups ? window.userGroups : []
            if(str.length > 1 && searchData.length) {
                for(let idx in searchData){
                    if(searchData[idx].name.toLowerCase().indexOf(str) !== -1){
                        filtered.push(this.makeListObject(idx, searchData, searchData[idx]))
                    }
                }
            }
            if(filtered.length > 0) {
                this.onSearchInputFocus();
            }
            this.setState({filteredData:filtered})
    }
    
    render(){
        
        return(
            <div className="GroupNav">
                <div className="h-nav-search">
                    <div className="hns-input">
                        <input type="text" placeholder="Search Group" ref="searchInput"
                               onFocus={this.onSearchInputFocus}
                               onBlur={this.onSearchInputBlur}
                               onChange={this.search}
                               />
                    </div>
                    <div className={Dom.Class({'active': this.isListBoxOpened()}, "hns-list")}>
                        {
                            this.state.filteredData.map((item,idx) => {
                                return (
                                    <div className="hnsl-item"
                                         key={idx} onMouseDown={() => this.navigate(item)}>
                                             <div className="hnsli-name" key={idx}>
                                                    {item.name}
                                             </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="h-nav">
                    <div className="hn-container">
                        {this.getGroupData().map((item,idx) => {
                            return (
                               item.path ? (
                                <div className="hn-item" key={idx} onMouseEnter={()=>this.setMode(item)} onMouseLeave={()=>this.setMode(false)}>
                                    <div className="hni-name"  onClick={() => this.navigate(item, idx)}>
                                        {item.name}
                                        <div className="hni-icon"><span className="fa fa-chevron-right"></span></div>
                                    </div>
                                    {
                                        item.children && item.children.length ? (
                                            <div className="hni-children" ref="children">
                                                {
                                                    item.children.sort((a,b)=>{
                                                        if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                                                        if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                                                        return 0;
                                                    }).map((child,jdx) => {
                                                        return (
                                                           child.path ?( <div className={Dom.Class({'active': this.state.selectedItem.id === child.id}, "hnic-item")}
                                                                 onClick={() => this.navigate(child)}
                                                                 onMouseOver={()=>this.setItem(child)}
                                                                 key={jdx}>{child.name}
                                                            </div>) : null
                                                        )
                                                    })
                                                }
                                            </div>
                                        ) : ""
                                    }
                                </div>) : null
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }
}
export default GroupNav;
